import {ActionTypes} from './../../cc-imports'

const HelpActions = {

    showHelp: (tab)=> {
        return {
            type: ActionTypes.SHOW_HELP,
            payload : {
                tab: tab
            }
        }
    }
};

export default HelpActions



// WEBPACK FOOTER //
// ./src/app/data/actions/HelpActions.js